import i18next from "i18next";
import * as yup from "yup";

export default function validation() {
  return yup.object().shape({
    name: yup
      .string()
      .required(
        i18next.t("validation.adminManageSubscription.subscriptionName")
      )
      .matches(/^[^\s].+[^\s]$/g, i18next.t("validation.common.noSpace"))
      .min(3, "Minimum 3 Character required")
      .trim(i18next.t("validation.common.noSpace")),
    amount: yup
      .number("Price must be a number")
      .positive("Price must be a positive value")
      .required(
        i18next.t("validation.adminManageSubscription.subscriptionAmount")
      ),
    storage: yup
      .number("storage must be number")
      .positive("storage must be a positive value")
      .required(i18next.t("validation.adminManageSubscription.storage")),
  });
}
